module.exports = __webpack_public_path__ + "img/cy_demo.25a1d485.png";